<template>
  <div class="personal-survey">
    <form class="edit-form" @submit.prevent="submit">
      <SurveyField v-for="(field, i) in fields" :key="i" v-model="form[field.name]" :field="field"/>

      <button :disabled="sending" type="submit" class="dark-blue-button">
        <div v-if="sending" class="css-loader css-loader-small"></div>
        <span v-else>{{ $t("שמור שינויים") }}</span>
      </button>

      <div v-if="success" class="form-success">{{ $t("השינויים נשמרו בהצלחה.") }}</div>
    </form>
  </div>
</template>

<script>
import SurveyField from "./SurveyField.vue";
import { api } from "../../API";

export default {
  components: {
    SurveyField
  },
  data() {
    return {
      sending: false,
      success: false,
      errors: {},
      form: window.siteData.customer_data.survey,
      fields: window.siteData.survey_fields
    };
  },
  methods: {
    submit() {
      this.sending = true;
      this.success = false;
      this.errors = {};

      api
        .customerUpdateSurvey(this.form)
        .then(resp => {
          this.success = true;
        })
        .catch(err => {
          if (err.responseJSON && err.responseJSON.data) {
            this.errors = err.responseJSON.data.errors;
          }
          this.success = false;
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }
};
</script>
